import React, { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { VideoProvider } from '../components/VideoProvider';
import generateConnectionOptions from '../util/generateConnectionOptions/generateConnectionOptions';
import GroupVideoCall from '../components/groupRoom/GroupVideoCall';
import { fetchFromRestAPI } from '../util/api';
import { useNavigate, useParams } from 'react-router';
import { BarLoader } from 'react-spinners';
import { isEmpty } from "lodash";

const settings = {
  bandwidthProfileMode: 'predicted',
  mode: 'collaboration',
  maxTracks: 10,
};

const override = {
  display: 'block',
  margin: '150px auto 0 auto',
  borderColor: 'red',
};

const GroupCallContainer: FC = () => {
  const navigate = useNavigate();
  const { code } = useParams<{ code: string }>();
  const { data: room } = useQuery({
    queryKey: ['/api/v1/group-rooms/', code],
    queryFn: async () => {
      if (code && code.length === 4) {
        const response = await fetchFromRestAPI(`/api/v1/group-rooms/${code}`);
        if (response && response.error) {
          navigate(`/404`);
        } else {
          return response;
        }
      } else {
        navigate(`/404`);
      }
    },
    enabled: !isEmpty(code),
  });

  // TODO better loading indicator
  if (!room) {
    return <BarLoader style={override} color={'#ff695f'} loading={!room} />;
  }

  const connectionOptions = generateConnectionOptions(settings);

  return (
    <VideoProvider
      options={connectionOptions}
      isP2P={room?.type === 'P2P'}
      pinRequired={room?.pinRequired}
      onError={(err) => console.error(err)}
    >
      <GroupVideoCall />
    </VideoProvider>
  );
};

export default GroupCallContainer;
